export default {
  'salesReport.title': '收入报表',
  'salesReport.tab.overview': '概览',
  'salesReport.tab.sales': '销售明细',
  'salesReport.tab.service_period': '就餐时段',
  'salesReport.tab.sales_summary': '销售概览',
  'salesReport.tab.periodic_trend': '趋势报表',
  'salesReport.tab.section_sales': '区域销售',

  'salesReport.tab.sales_category': '销售分类',
  'salesReport.export.dailySales': '导出每日销售统计报表',
  'salesReport.export.trendDish': '导出热门菜品统计报表',
  'salesReport.export.dailyPayout': '导出日打款记录',
  'salesReport.summary': '累计销售概要',
  'salesReport.summary.miscellaneous': '各项杂费',
  'salesReport.totalItems': '{count}道菜',
  'salesReport.totalOrders': '{count}个订单',
  'salesReport.totalTips': '小费总计',
  'salesReport.totalCardTips': '刷卡小费',
  'salesReport.totalCashTips': '现金小费',
  'salesReport.totalOtherTips': '其他小费',
  'salesReport.averageGrossSales': '单均销售额',
  'salesReport.summary.payment': '付款方式数据',
  'salesReport.summary.type': '类型数据',
  'salesReport.totalCash': '现金总额',
  'salesReport.totalCard': '刷卡总额',
  'salesReport.totalOthers': '其他支付总额',
  'salesReport.totalOtherPayments': '其他支付方式总计',
  'salesReport.totalOnline': '线上总额',
  'salesReport.totalAvailableToPayout': '应打款金额',
  'salesReport.totalDiscount': '总折扣',
  'salesReport.totalDiscount.summary': '占总销售额的{percentage}%',
  'salesReport.totalVoids': '作废',
  'salesReport.totalRefunds': '退款总额',
  'salesReport.totalVoids.summary': '{voidCount}道菜',
  'salesReport.totalNonTaxableFee': '免税费用总计',
  'salesReport.totalTaxableFee': '征税费用总计',
  'salesReport.online.summary':
    '线上销售的总销售额可能不包含平台加价、佣金、税和费用等。如用于报税为目的，请参考各平台的每月月结单或1099-MISC表格。',

  'report.title': '报表',
  'report.column.name': '姓名',
  'report.column.date': '日期',
  'report.column.range': '日期区间',
  'report.column.gmv_commission': '佣金',
  'report.column.available_payout_amount': '可打款额',
  'report.column.debt': '欠款',
  'report.column.other_amount': '其他款项',
  'report.column.restaurant_name': '餐厅名称',

  'report.column.bill_count': '完成订单数',
  'report.column.order_count': '完成订单数',
  'report.column.open_order_count': '未完成订单数',
  'report.column.canceled_order_count': '已取消订单数',
  'report.column.payment_count': '支付总笔数',
  'report.column.item_voids_value': '作废菜品金额',
  'report.column.voids': '作废菜品金额',
  'report.column.item_voids': '作废菜品数',
  'report.column.voids_count': '作废菜品数',
  'report.column.comps': '补偿',
  'report.column.comps_count': '补偿笔数',
  'report.column.comp_value': '补偿',
  'report.column.gross_sales': '总销售额',
  'report.column.gross_refunds': '总退款',
  'report.column.excess_payments': '超额付款',
  'report.column.avg_order_value': '平均订单金额',
  'report.column.avg_table_duration': '平均占桌时间',
  'report.column.discounts': '折扣',
  'report.column.discounts_rate': '折扣百分比',
  'report.column.tips': '服务小费',
  'report.column.staff_tips': '服务小费',
  'report.column.staff_tips_refunds': '服务小费退款',
  'report.column.driver_tips': '递送小费',
  'report.column.driver_tips_refunds': '递送小费退款',
  'report.column.commissions': '佣金',
  'report.column.commissions_refunds': '佣金退款',
  'report.column.commission': '佣金',
  'report.column.tips_refund': '小费退款',
  'report.column.tips_rate': '小费百分比',
  'report.column.taxes': '税',
  'report.column.taxes_refunds': '税退款',
  'report.column.refunds': '退款',
  'report.column.payment_amount_refunds': '支付退款',
  'report.column.reopen_amount_refunds': '重开单退款',
  'report.column.net_refunds': '退款',
  'report.column.net_sales': '税前营业额',
  'report.column.net_sales_refunds': '税前营业额退款',
  'report.column.amount_collected': '实收金额',
  'report.column.amount_receivable': '应收金额',
  'report.column.cash_amount_collected': '现金支付金额',
  'report.column.card_amount_collected': '刷卡支付金额',
  'report.column.online_amount_collected': '线上支付金额',
  'report.column.other_amount_collected': '其他支付金额',
  'report.column.fees_collected': '费用',
  'report.column.fees': '费用',
  'report.column.fees_refunds': '费用退款',
  'report.column.average_checks': '平均账单额',
  'report.column.adjustments': '调整',
  'report.column.deferred_sales': '预付总计',
  'report.column.deferred_sales.total': '总计',
  'report.column.deferred_sales.totalItems': '{count}笔充值',
  'report.column.volume': '成交量',
  'report.section.orders': '订单',
  'report.section.stats': '数据',
  'report.section.sale_proportion': '销售比例',
  'report.section.online_platform_breakdown': '线上平台分析',
  'report.section.online_platform_sales_trend': '线上平台销售走势',
  'report.service_type.placeholder': '选择服务类型',
  'report.order_source.placeholder': '选择订单来源',
  'report.order.summary': '{count}个订单',
  'report.order.total_summary': '总订单',
  'report.description.gross_sales':
    '总销售额是所有订单菜品金额的总和，不包括佣金，税费，小费，费用和金额调整。折扣和退款不影响总销售额。',
  'report.description.net_sales': '<b>税前营业额</b>是指总销售额减去折扣金额',
  'report.description.amount_collected':
    '<b>应收金额</b>是指现金营业额、刷卡营业额与线上营业额的综合。<br /><b>线上支付金额</b>是指在Chowbus POS平台上创建的在线订单的粗略金额。最终金额根据每个在线平台收取的税款和费用而有所不同。',
  'report.description.online_amount_collected':
    '线上支付金额是通过Chowbus POS统计的线上订单数据，得出的预估营业额。最终金额会根据各平台的税和费用有所浮动。',
  'report.description.average_checks': '我们根据客户在订单来源为堂食/电话订餐的订单上支付的总金额来计算此数值。',
  'report.description.tip_rate': '小费百分比是基于{base}。',
  'report.description.discount_rate': '折扣百分比是以小计（税前）计算。',
  'report.description.canceled_orders': '已取消订单不计入销售数据中。',
  'report.placeholder.filter.order_source': '按订单来源筛选',
  'report.placeholder.filter.employee': '按员工筛选，可多选',
  'report.column.feesAndAdjustment': '费用 & 调整',
  'report.column.availabelToPayoutAmount': '可打款金额',
  'report.column.fix_rate': '固定利率费',
  'report.column.saas_fee': '服务费',
  'report.column.income_adjustment': '调整',
  'report.column.sales_payout_amount': '可打款销售额',
  'report.column.summary': '合计',
  'report.column.net_cash': '净现金收入',
  'report.column.dine_in_guests': '堂食客人数量',
  'report.payment.count': '笔数',
  'report.payment.amount': '营业额',
  'report.payment.tips': '小费',
  'report.payment.total': '支付总额',

  'salesReport.section.byServiceType': '服务类型',
  'salesReport.section.byOrderSource': '订单来源',
  'salesReport.section.salesTrends': '销售趋势',
  'salesReport.section.salesByMenu': '菜单',
  'salesReport.section.salesByCategory': '分类',
  'salesReport.section.salesByDish': '菜品 & 附加选项明细',
  'salesReport.section.salesBreakdown': '销售明细',
  'salesReport.section.salesByCustomizations': '附加选项',
  'salesReport.section.dailySales': '每日销售统计',
  'salesReport.section.byPlatform': '平台来源',
  'salesReport.section.salesTrendsByPlatform': '销售趋势，按平台来源区分',
  'salesReport.section.availableToPayout': '可打款统计',
  'salesReport.section.deferredSales': '预付金额',

  'salesReport.breakout.fees': '总费用',
  'salesReport.breakout.tips': '小费合计',
  'salesReport.breakout.commissions': '总佣金',
  'salesReport.breakout.taxes': '税总额',
  'salesReport.breakout.discounts': '总折扣',

  'salesReport.summary.dailySales': '销售总计',
  'salesReport.summary.payoutByDate': '打款总计',
  'salesReport.summary.restaurantsSales': '餐厅销售总计',

  'report.filter.menu': '按菜单筛选',
  'report.filter.category': '按分类筛选',
  'report.filter.dish': '按菜品筛选',
  'report.column.category_name': '分类',
  'report.column.dish_count': '数量',
  'report.column.dish_name': '菜品',
  'report.column.customization_name': '附加选项名',
  'report.column.menu_name': '菜单名',

  'report.sheet.salesByMenu': '按菜单统计销售',
  'report.sheet.salesByCategory': '按分类统计销售',
  'report.sheet.salesByDish': '按菜品 & 附加选项统计销售',
  'report.sheet.salesByCustomizations': '按附加选项统计销售',

  'report.dishType.dishes': '菜品',
  'report.dishType.rewards': '兑换商品',

  'salesReport.collectSummary.totalAmountBeforeRefund': '总交易额(退款前)',
  'salesReport.collectSummary.totalRefund': '退款金额',
  'salesReport.collectSummary.totalAmountAfterRefund': '总交易额',
  'salesReport.refundAmount.card': '刷卡退款总额',
  'salesReport.refundAmount.cash': '现金退款总额',
  'salesReport.refundAmount.other': '其他支付退款总额',
  'salesReport.refundAmount.online': '线上支付退款金额',

  'salesReport.salesCategory.table.title': '根据销售分类',
  'salesReport.salesCategory.select.label': '销售分类选择',
  'salesReport.salesCategory.button.update': '更新',
};
